/* ============================================
   MODA FOCA — Custom Scripts for Shopify Horizon
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  // --- Scroll-triggered reveal animations ---
  const revealElements = document.querySelectorAll('.mf-reveal');

  if (revealElements.length) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mf-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -60px 0px'
    });

    revealElements.forEach(el => revealObserver.observe(el));
  }

  // --- Parallax on hero ---
  const hero = document.querySelector('.mf-hero');
  const heroContent = document.querySelector('.mf-hero__content');

  if (hero && heroContent) {
    window.addEventListener('scroll', () => {
      if (window.scrollY < window.innerHeight) {
        const offset = window.scrollY * 0.3;
        heroContent.style.transform = `translateY(${offset}px)`;
        heroContent.style.opacity = 1 - (window.scrollY / window.innerHeight) * 0.8;
      }
    }, { passive: true });
  }

  // --- Parallax on story visual ---
  const storyVisual = document.querySelector('.mf-story__visual');
  if (storyVisual) {
    const storyVisualBg = storyVisual.querySelector('.mf-story__visual-bg');
    if (storyVisualBg) {
      window.addEventListener('scroll', () => {
        const rect = storyVisual.getBoundingClientRect();
        const viewHeight = window.innerHeight;
        if (rect.top < viewHeight && rect.bottom > 0) {
          const progress = (viewHeight - rect.top) / (viewHeight + rect.height);
          const offset = (progress - 0.5) * 60;
          storyVisualBg.style.transform = `translateY(${offset}px)`;
        }
      }, { passive: true });
    }
  }

  // --- Smooth scroll for anchor links ---
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
